// Generiert aus LIAN_next-step_Hallenplan_2026_DRUCK.pdf via scripts/build-plan.py — nicht von Hand bearbeiten.
// Die Flaechen decken sich exakt mit den Standumrandungen im Druckplan.

export const planViewBox = '0 0 859.962 571.406'

export type BoothArea = {
  booth: string
  hall: 'foyer' | 'saal' | 'lindahof'
  x: number
  y: number
  width: number
  height: number
  opacity: number
}

export const boothAreas: BoothArea[] = [
  { booth: '1.01', hall: 'foyer', x: 247.37, y: 425.01, width: 25.48, height: 41.06, opacity: 0.4 },
  { booth: '1.02', hall: 'foyer', x: 247.37, y: 398.68, width: 25.48, height: 26.18, opacity: 0.4 },
  { booth: '1.03', hall: 'foyer', x: 247.37, y: 372.51, width: 25.48, height: 26.18, opacity: 0.4 },
  { booth: '1.04', hall: 'foyer', x: 247.33, y: 346.39, width: 25.52, height: 25.90, opacity: 0.4 },
  { booth: '1.05', hall: 'foyer', x: 247.37, y: 320.21, width: 25.48, height: 26.18, opacity: 0.4 },
  { booth: '1.06', hall: 'foyer', x: 247.33, y: 294.09, width: 25.52, height: 25.90, opacity: 0.4 },
  { booth: '1.07', hall: 'foyer', x: 247.37, y: 267.91, width: 25.48, height: 26.18, opacity: 0.4 },
  { booth: '1.08', hall: 'foyer', x: 247.33, y: 241.79, width: 25.52, height: 25.90, opacity: 0.4 },
  { booth: '1.09', hall: 'foyer', x: 315.24, y: 403.02, width: 25.49, height: 26.18, opacity: 0.4 },
  { booth: '1.10', hall: 'foyer', x: 315.20, y: 361.81, width: 25.49, height: 41.06, opacity: 0.4 },
  { booth: '1.11', hall: 'foyer', x: 315.24, y: 335.63, width: 25.49, height: 26.18, opacity: 0.4 },
  { booth: '1.12', hall: 'foyer', x: 315.24, y: 309.45, width: 25.49, height: 26.18, opacity: 0.4 },
  { booth: '1.13', hall: 'foyer', x: 315.24, y: 283.10, width: 25.49, height: 26.18, opacity: 0.4 },
  { booth: '1.14', hall: 'foyer', x: 315.20, y: 256.98, width: 62.69, height: 25.90, opacity: 0.4 },
  { booth: '1.15', hall: 'foyer', x: 269.63, y: 192.57, width: 41.06, height: 25.48, opacity: 0.4 },
  { booth: '1.16', hall: 'foyer', x: 310.35, y: 192.57, width: 41.06, height: 25.48, opacity: 0.4 },
  { booth: '1.17', hall: 'foyer', x: 403.60, y: 208.83, width: 30.97, height: 37.99, opacity: 0.4 },
  { booth: '1.18', hall: 'foyer', x: 434.57, y: 191.43, width: 69.19, height: 55.39, opacity: 0.4 },
  { booth: '2.01', hall: 'saal', x: 465.24, y: 285.26, width: 36.11, height: 28.32, opacity: 0.4 },
  { booth: '2.02', hall: 'saal', x: 412.91, y: 285.26, width: 52.34, height: 28.32, opacity: 0.4 },
  { booth: '2.03', hall: 'saal', x: 376.75, y: 320.16, width: 28.32, height: 72.21, opacity: 0.4 },
  { booth: '2.04', hall: 'saal', x: 439.72, y: 349.99, width: 65.19, height: 72.21, opacity: 0.4 },
  { booth: '2.05', hall: 'saal', x: 439.72, y: 422.20, width: 36.46, height: 60.18, opacity: 0.4 },
  { booth: '2.06', hall: 'saal', x: 376.75, y: 444.89, width: 28.32, height: 41.55, opacity: 0.4 },
  { booth: '2.07', hall: 'saal', x: 376.75, y: 486.44, width: 28.32, height: 28.39, opacity: 0.4 },
  { booth: '2.08', hall: 'saal', x: 440.07, y: 512.27, width: 36.10, height: 28.32, opacity: 0.4 },
  { booth: '2.09', hall: 'saal', x: 476.18, y: 443.84, width: 42.87, height: 38.54, opacity: 0.4 },
  { booth: '2.10', hall: 'saal', x: 476.18, y: 512.27, width: 72.93, height: 28.32, opacity: 0.4 },
  { booth: '2.11', hall: 'saal', x: 519.04, y: 443.84, width: 42.87, height: 38.54, opacity: 0.4 },
  { booth: '2.12', hall: 'saal', x: 549.11, y: 512.27, width: 48.85, height: 28.32, opacity: 0.4 },
  { booth: '2.13', hall: 'saal', x: 562.02, y: 422.20, width: 88.08, height: 60.18, opacity: 0.4 },
  { booth: '2.14', hall: 'saal', x: 597.96, y: 512.27, width: 36.22, height: 28.32, opacity: 0.4 },
  { booth: '2.14', hall: 'saal', x: 663.61, y: 476.73, width: 37.27, height: 36.11, opacity: 0.4 },
  { booth: '2.15', hall: 'saal', x: 662.12, y: 408.88, width: 36.11, height: 32.13, opacity: 0.4 },
  { booth: '2.16', hall: 'saal', x: 725.02, y: 490.43, width: 36.11, height: 28.32, opacity: 0.4 },
  { booth: '2.17', hall: 'saal', x: 797.32, y: 414.21, width: 28.32, height: 41.43, opacity: 0.4 },
  { booth: '2.18', hall: 'saal', x: 702.87, y: 388.65, width: 23.98, height: 52.36, opacity: 0.4 },
  { booth: '2.19', hall: 'saal', x: 797.32, y: 393.94, width: 28.32, height: 20.26, opacity: 0.4 },
  { booth: '2.20', hall: 'saal', x: 712.69, y: 304.39, width: 32.85, height: 45.42, opacity: 0.4 },
  { booth: '2.21', hall: 'saal', x: 672.75, y: 323.10, width: 24.25, height: 20.23, opacity: 0.4 },
  { booth: '2.22', hall: 'saal', x: 591.96, y: 287.91, width: 36.11, height: 28.32, opacity: 0.4 },
  { booth: '2.23', hall: 'saal', x: 662.12, y: 388.65, width: 24.25, height: 20.23, opacity: 0.4 },
  { booth: '2.24', hall: 'saal', x: 582.37, y: 393.88, width: 67.73, height: 28.32, opacity: 0.4 },
  { booth: '2.25', hall: 'saal', x: 533.27, y: 393.88, width: 49.11, height: 28.32, opacity: 0.4 },
  { booth: '2.26', hall: 'saal', x: 504.91, y: 357.25, width: 28.32, height: 42.42, opacity: 0.4 },
  { booth: '2.27', hall: 'saal', x: 532.40, y: 287.76, width: 28.32, height: 25.85, opacity: 0.4 },
  { booth: '3.01', hall: 'lindahof', x: 67.71, y: 410.45, width: 70.61, height: 70.61, opacity: 0.2 },
  { booth: '3.02', hall: 'lindahof', x: 138.14, y: 410.45, width: 70.60, height: 70.61, opacity: 0.2 },
  { booth: '3.03', hall: 'lindahof', x: 67.56, y: 238.67, width: 70.60, height: 70.61, opacity: 0.2 },
  { booth: '3.04', hall: 'lindahof', x: 137.98, y: 238.67, width: 70.61, height: 70.61, opacity: 0.2 },
]
